import axios from 'axios';
export const MENU_REQUEST = 'MENU_REQUEST'
export const MENU_SUCCESS = 'MENU_SUCCESS'
export const MENU_FAIL = 'MENU_FAIL'

export const menuRequest = () => {
  return {
    type: MENU_REQUEST
  }
}

export const menuSuccess = (data) => {
  return {
    type: MENU_SUCCESS,
    menu: data
  }
}

export const menuFail = () => {
  return {
    type: MENU_FAIL
  }
}

export const menuManager = (userId) => {
  return (dispatch) => {
    dispatch(menuRequest());
    return axios.get('/api/mnat/getMenu', { params: { userId: userId }})
      .then(response => {
        dispatch(menuSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(menuFail());
        console.log(error);
      });
  }
}

export const menus = (state = {status: 'WAITING'}, action) => {
  switch (action.type) {
    case 'MENU_REQUEST':
      return {
        ...state,
        status: 'WAITING'
      }
    case 'MENU_SUCCESS':
      return {
        menu: [...action.menu],
        status: 'SUCCESS'
      }
    case 'MENU_FAIL':
      return {
        status: 'FAIL'
      }
    default:
      return state
  }
}